// Untyped re-export of the Supabase client for Creator/Brand DB proxy operations.
// The auto-generated types only cover Admin DB tables (cap_data, cap_upload_history).
// Components accessing Creator or Brand DB tables via admin-proxy should import from here
// to avoid TypeScript errors on unknown table names.

import { supabase as typedClient } from '@/integrations/supabase/client';

export const supabase = typedClient as any;
export const brandSupabase = typedClient as any;
